import React, { useEffect } from "react";
import { accionesItems } from "../../json/acciones";
import { Link } from 'react-router-dom';
import './acciones.css';


const Acciones = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container areas-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='acciones_title'>
                    <h1>Acciones</h1>
                </div>
            </div>
        </div>
        <div className="row">

          {accionesItems.map((item, index ) => (
            
<Link key={ index } to={ item.enlace ? item.enlace : "DetalleRubro/" + item.enlace } className='col-md-4 col-sm-6 col-12'>
<div class="card card-administrativo">
                    <div class="card-body">
                        <article>
                        <img src={item.imagen2} class="card-img-top"/>
                            <img src={item.imagen2} class="card-img-top"/>
                            
                        </article>

                    </div>
                </div>
                
                </Link>
            
          ))}                            
        </div>
    </div>
  );
};

export default Acciones;